import React, {useState} from 'react';
import {
  getAuth,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import {
  AppProvider,
  TextField,
  Page,
  Stack,
  Button,
  Form,
} from '@shopify/polaris';
import {useNavigate} from 'react-router-dom';

export default function Login() {
  const [emailValue, setEmailValue] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const navigate = useNavigate();
  const auth = getAuth();

  const handleEmailChange = (value) => {
    setEmailValue(value);
  };

  const handlePasswordChange = (value) => {
    setPasswordValue(value);
  };

  const handleSignupClick = () => {
    navigate('/signup');
  };

  const handleLoginClick = () => {
    signInWithEmailAndPassword(
      auth,
      emailValue,
      passwordValue,
    )
      .then(() => {
        navigate('/messaging');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <AppProvider>
      <Page>
        <Stack spacing="extraLoose">
          <Form onSubmit={handleLoginClick}>
            <TextField
              value={emailValue}
              onChange={handleEmailChange}
              placeholder="Email"
              type="email"
            />
            <TextField
              value={passwordValue}
              onChange={handlePasswordChange}
              placeholder="Password"
              type="password"
            />
            <Button onClick={handleLoginClick}>
              Log in
            </Button>
            <Button onClick={handleSignupClick}>
              Sign up
            </Button>
          </Form>
        </Stack>
      </Page>
    </AppProvider>
  );
}
